var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCaretRightRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.8mm",
    height: "3.3mm",
    viewBox: "0 0 7.94 9.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d96f2b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_\\u591A\\u89D2\\u5F62_6",
    className: "cls-1",
    d: "M7.5,3.9c.4,.3,.6,.8,.3,1.3l-.3,.3L1.4,9.19c-.4,.3-1,.2-1.3-.3-.1-.1-.1-.3-.1-.5V.9C0,.4,.4,0,.9,0c.2,0,.3,0,.5,.1L7.5,3.9Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretRightRed);
export default __webpack_public_path__ + "static/media/icon_caret_right_red.c895e7950a646f53cc1c157553e2bd38.svg";
export { ForwardRef as ReactComponent };